export default __webpack_public_path__ + "static/media/94_desktop.91ac40b2.jpg";